<template>
  <div class="mb-decision-tree" @click="cancelCheck()">
    <img
      v-if="startGameConfig.mainImage"
      @click="cancelCheck()"
      class="main-img"
      draggable="false"
      :src="giveMeImagePlease(startGameConfig.mainImage.imagePath)"
      :style="{
        width: setValue(startGameConfig.mainImage.width, 1920) + 'px',
        height: setValue(startGameConfig.mainImage.height, 1080) + 'px',
        top: setValue(startGameConfig.mainImage.pos.x, 0) + 'px',
        left: setValue(startGameConfig.mainImage.pos.y, 0) + 'px',
      }"
    />
    <div
      :key="'mb-decision-tree-item-' + index"
      class="mb-decision-tree-item"
      v-for="(it, index) in items"
      :style="{
        width: setValue(it.width, 200) + 'px',
        height: setValue(it.height, 200) + 'px',
        top: setValue(it.pos.y, 0) + 'px',
        left: setValue(it.pos.x, 0) + 'px',
        background: setValue(it.background, 'transparen'),
        backgroundImage: it.backgroundImage ? 'url(' + giveMeImagePlease(it.backgroundImage) + ')' : '',
        backgroundSize: 'cover',
        filter: it.level < currentIndex && !correct.some((x) => x == it.id) ? 'grayscale(100%)' : 'grayscale(0%)',
      }"
    >
      <img
        :src="giveMeImagePlease(it.src)"
        draggable="false"
        @click="checkAnswer(it.level, it.id, it.audioOnClick)"
        :style="{
          cursor: it.noClicable ? 'default' : 'pointer',
        }"
        style="width: 100%; height: 100%; position: absolute; top: 0; left: 0"
      />
      <div class="blocker" v-if="it.level < currentIndex || clickBlock">
        <div
          class="mb-listen-and-point-item-correct-items"
          v-if="it.correctItems && it.level < currentIndex && correct.some((x) => x == it.id)"
        >
          <img
            :key="'mb-listen-and-point-item-correct-items-image-' + indexCorrImgCorr"
            class="mb-listen-and-point-item-correct-image"
            draggable="false"
            v-for="(correctImgCorr, indexCorrImgCorr) in it.correctItems.images"
            :src="giveMeImagePlease(correctImgCorr.src)"
            :style="[
              {
                position: 'absolute',
                width: setValue(correctImgCorr.width, 100) + 'px',
                height: setValue(correctImgCorr.height, 100) + 'px',
                top: correctImgCorr.pos ? setValue(correctImgCorr.pos.y, 0) + 'px' : '0' + 'px',
                left: correctImgCorr.pos ? setValue(correctImgCorr.pos.x, 0) + 'px' : '0' + 'px',
              },
              correctImgCorr.cssStyle,
            ]"
          />
        </div>
      </div>
      <div
        class="audio"
        v-if="it.audio && currentIndex == it.level"
        style="max-width: 100%; pointer-events: stroke; max-height: 100%"
      >
        <div
          v-if="checkAudioIcon()"
          @click="playFieldAudio(it.audio)"
          style="width: 100%; height: 100%; position: absolute; top: 0; left: 0"
        >
          <img
            :src="giveMeImagePlease(startGameConfig.audio.icon.on)"
            draggable="false"
            v-if="!it.audioStatus"
            style="width: 100%; height: 100%; position: absolute; top: 0; left: 0"
          />
          <img
            :src="giveMeImagePlease(startGameConfig.audio.icon.off)"
            draggable="false"
            v-if="it.audioStatus"
            style="width: 100%; height: 100%; position: absolute; top: 0; left: 0"
          />
        </div>
        <svg
          v-if="!checkAudioIcon()"
          @click="playFieldAudio(it.audio)"
          class="audio-svg-button"
          viewBox="0 0 24 24"
          style="cursor: pointer"
        >
          <transition name="click-fade">
            <path
              v-if="!it.audioStatus"
              d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"
            />
          </transition>
          <transition name="click-fade">
            <path
              v-if="it.audioStatus"
              d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"
            />
          </transition>
        </svg>
      </div>
    </div>
    <div
      :key="'mb-decision-tree-audio-' + index"
      class="mb-decision-tree-item"
      v-for="(it, index) in audio"
      :style="{
        width: setValue(it.width, 200) + 'px',
        height: setValue(it.height, 200) + 'px',
        top: setValue(it.pos.y, 0) + 'px',
        left: setValue(it.pos.x, 0) + 'px',
        background: setValue(it.background, 'transparen'),
      }"
    >
      <div
        class="audio"
        v-if="it.audio && currentIndex == it.level"
        style="max-width: 100%; pointer-events: stroke; max-height: 100%"
      >
        <div
          v-if="checkAudioIcon()"
          @click="playFieldAudio(it.audio)"
          style="width: 100%; height: 100%; position: absolute; top: 0; left: 0"
        >
          <img
            :src="giveMeImagePlease(startGameConfig.audio.icon.on)"
            draggable="false"
            v-if="!it.audioStatus"
            style="width: 100%; height: 100%; position: absolute; top: 0; left: 0"
          />
          <img
            :src="giveMeImagePlease(startGameConfig.audio.icon.off)"
            draggable="false"
            v-if="it.audioStatus"
            style="width: 100%; height: 100%; position: absolute; top: 0; left: 0"
          />
        </div>
        <svg
          v-if="!checkAudioIcon()"
          @click="playFieldAudio(it.audio)"
          class="audio-svg-button"
          viewBox="0 0 24 24"
          style="cursor: pointer"
        >
          <transition name="click-fade">
            <path
              v-if="!it.audioStatus"
              d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"
            />
          </transition>
          <transition name="click-fade">
            <path
              v-if="it.audioStatus"
              d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"
            />
          </transition>
        </svg>
      </div>
    </div>
  </div>
</template>
<script>
import { Howler } from 'howler';
import _ from 'lodash';
import defaultMixin from '../../mixins/defaultMixin';
export default {
  name: 'mb-decision-tree',
  mixins: [defaultMixin],
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
    assets: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      canIPlayASong: true,
      items: [],
      clickBlock: true,
      blockItems: false,
      currentIndex: 0,
      hoverOnIcon: [],
      audioClick: null,
      audioNegative: null,
      audioPositive: null,
      audio: [],
      correct: [],
    };
  },
  created() {},
  beforeDestroy() {},
  beforeMount() {},
  mounted() {
    this.setGameAudio();
    this.init();
  },
  methods: {
    checkItem(level, id, clickAudio) {
      if (this.correct[level] == id) {
        this.currentIndex = level + 1;
        this.audioPositive.play();
        this.clickBlock = true;
        setTimeout(() => {
          this.blockItems = false;
          if (clickAudio) {
            console.log('clickAudio : ' + clickAudio._duration);
            clickAudio.play();
            setTimeout(() => {
              if (this.checkAllIndex()) {
                this.$store.dispatch('checkGame');
              }
            }, clickAudio._duration * 1000 + 0);
          } else {
            if (this.checkAllIndex()) {
              this.$store.dispatch('checkGame');
            }
          }
        }, this.audioPositive._duration * 100 + 100);
      } else {
        this.audioNegative.play();
        setTimeout(() => {
          this.blockItems = false;
        }, this.audioNegative._duration * 100 + 100);
      }
    },
    checkAnswer(level, id, clickAudio) {
      if (level == this.currentIndex) {
        try {
          this.audio[this.currentIndex].audio.stop();
        } catch (err) {
          console.log('noAudio');
        }
        if (!this.blockItems) {
          this.blockItems = true;
          this.checkItem(level, id, clickAudio);
        }
      }
    },
    cancelCheck() {
      this.$store.commit('CHANGE_CHECK_SWITCH', false);
    },
    checkAudioIcon() {
      if (this.startGameConfig.audio) {
        if (this.startGameConfig.audio.icon) return true;
      }
      return false;
    },
    checkAllIndex() {
      if (this.currentIndex == this.correct.length) {
        return true;
      } else return false;
    },
    checkGameAction() {
      return this.checkAllIndex();
    },
    playFieldAudio(audio) {
      this.clickBlock = false;
      console.log(this.canIPlayASong);
      if (audio && this.canIPlayASong) {
        audio.play();
      } else if (audio) {
        audio.stop();
      }
    },
    aduioStatus(index, value) {
      let it = this.audio[index];
      it.audioStatus = value;
      this.$set(this.audio, index, it);
    },
    correctStatus(index, value) {
      let it = this.items[index];
      it.correctStatus = value;
      this.$set(this.items, index, it);
    },
    audioCreate(src, index) {
      return new Howl({
        src: this.giveMeImagePlease(src),
        autoplay: false,
        loop: false,
        volume: 0.5,
        onend: () => {
          this.canIPlayASong = true;
          this.aduioStatus(index, false);
        },
        onstop: () => {
          this.canIPlayASong = true;
          this.aduioStatus(index, false);
        },
        onplay: () => {
          this.canIPlayASong = false;
          this.aduioStatus(index, true);
        },
      });
    },
    setItem(value, index, layout, config) {
      if (!value.pos) value.pos = layout[index].pos;
      value.audioStatus = false;
      if (value.audioData) {
        value.audio = this.audioCreate(value.audioData.src, index);
        value.hoverOnIcon = false;
      }
      if (value.clickAudio) {
        value.audioOnClick = new Howl({
          src: this.giveMeImagePlease(value.clickAudio),
          autoplay: false,
          loop: false,
          volume: 0.5,
          onend: () => {
            this.canIPlayASong = true;
          },
          onstop: () => {
            this.canIPlayASong = true;
          },
          onplay: () => {
            this.canIPlayASong = false;
          },
        });
      }
      if (!value.width) value.width = config.width;
      if (!value.height) value.height = config.height;
      if (!value.background) value.background = config.background;
      if (!value.backgroundImage) value.backgroundImage = config.backgroundImage;
    },
    createItems(value) {
      value.items.forEach((el, index) => {
        if (!el.noCorrectItem) {
          el.correctItems = value.correctItemsConfig;
        }
        this.setItem(el, index, value.layoutAudio, value.itemsConfig);
        this.items.push(el);
      });
    },
    init() {
      let itm = _.cloneDeep(this.startGameConfig);
      let tmpCorrect = _.cloneDeep(this.startGameConfig.correctWay);
      tmpCorrect = this.shuffle(tmpCorrect);
      this.correct = _.cloneDeep(tmpCorrect[0].way);
      this.audio = _.cloneDeep(tmpCorrect[0].items);
      this.audio.forEach((audioItem, index) => {
        this.setItem(audioItem, index, itm.layoutAudio, itm.audioConfig);
      });
      this.createItems(itm);
    },
    setValue(value, defaultValue) {
      if (value) return value;
      else return defaultValue;
    },
    giveMeImagePlease(path) {
      return require(`__staticDir/${this.$store.getters.multibookType}/${path}`);
    },
    resetGameAction() {
      if (!this.blockItems) {
        this.canIPlayASong = true;
        this.clickBlock = true;
        this.items = [];
        this.blockItems = false;
        this.currentIndex = 0;
        this.hoverOnIcon = [];
        this.correct = [];
        this.init();
      }
    },
    shuffle(a) {
      for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
      }
      return a;
    },
    setGameAudio() {
      if (this.startGameConfig.audio) {
        if (this.startGameConfig.audio.positive) {
          this.audioPositive = new Howl({
            src: this.giveMeImagePlease(this.startGameConfig.audio.positive),
            autoplay: false,
            loop: false,
            volume: 0.5,
          });
        }
        if (this.startGameConfig.audio.click) {
          this.audioClick = new Howl({
            src: this.giveMeImagePlease(this.startGameConfig.audio.click),
            autoplay: false,
            loop: false,
            volume: 0.5,
          });
        }
        if (this.startGameConfig.audio.negative) {
          this.audioNegative = new Howl({
            src: this.giveMeImagePlease(this.startGameConfig.audio.negative),
            autoplay: false,
            loop: false,
            volume: 0.5,
          });
        }
      }
    },
  },
  destroyed() {},
  computed: {
    backgroundImageUrl() {
      return 'static/' + this.startGameConfig.background;
    },
  },
};
</script>
<style lang="sass" scoped>
// @import '~pretty-checkbox/src/pretty-checkbox.scss';
@import '~@/assets/sass/variable'
@import '~@/assets/sass/iconColor'
$backgroundWidth: 1906px
$backgroundHeight: 900px
$backgroundOffsetTop: 140px
$backgroundOffsetLeft: 0
.main-img
  position: fixed
  object-fit: cover
.mb-decision-tree
  font-family: $gameFontFamily
  background-size: contain
  background-repeat: no-repeat
  position: absolute
  top: $backgroundOffsetTop
  left: $backgroundOffsetLeft
  height: $backgroundHeight
  width: 1920px
  // top: 50px
  display: flex
  justify-content: center
  align-items: center
  // flex-basis: 30%
  flex-wrap: wrap
  .mb-decision-tree-item
    position: absolute
    display: flex
    justify-content: center
    align-items: center
    cursor: pointer
    transition: .3s
    .mb-decision-tree-item-img
      width: 100%
      height: 100%
      top: 0
      left: 0
      position: absolute
    .blocker, .mb-decision-tree-item-correct-items
      width: 100%
      height: 100%
      // z-index: 2
      position: absolute
      top: 0
      left: 0
      cursor: auto
      .mb-decision-tree-item-correct-image
        position: absolute
    p
      margin: 0
    .audio
      display: flex
      justify-content: center
      align-items: center
      posistion: absolute
      border-radius: 50%
      color: $secondIconColor
      background-color: $firstIconColor
      transition: 0.2s
      &:hover
        color: $firstIconColor
        background-color: $secondIconColor
      .mb-items-text
        max-width: 100%
        max-height: 100%
        user-select: none
        margin: 0
      .audio-svg-button
        width: 100%
        height: 100%
        fill: white
        transition: 0.2s
        &:hover
          fill: #00a8ec



.memory-fade-leave-active, .memory-fade-enter-active
  transition: all .3s linear
.memory-fade-leave-to, .memory-fade-enter
  opacity: 0
</style>
